import React, { PropsWithChildren } from 'react';
import { css } from '@emotion/react';
import { PanelPortal, PanelHeader, PanelContent } from '@frontend/panel-engine';
import { ModalControlResponse } from '@frontend/design-system';

export const TopBarPanelContent = ({ children }: { children: React.ReactNode }) => (
  <div
    css={css`
      display: flex;
      flex-direction: column;
      position: relative;
      overflow: auto;
      flex-grow: 1;
    `}
  >
    {children}
  </div>
);

const ScheduleRequestPanelWrapper = ({
  children,
  onClose,
  modalProps,
}: PropsWithChildren<{ onClose: () => void; modalProps: ModalControlResponse }>) => {
  if (!modalProps.modalProps.show) {
    return null;
  }
  return (
    <PanelPortal id='schedule-request-info' width='medium' onClose={onClose}>
      {children}
    </PanelPortal>
  );
};

const ScheduleRequestPanelHeader = ({ children, onClose }: PropsWithChildren<{ onClose: () => void }>) => {
  return (
    <PanelHeader
      css={css`
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
      `}
    >
      <div>{children}</div>
      <PanelHeader.Close iconName='x' size='large' onClick={onClose} />
    </PanelHeader>
  );
};

const ScheduleRequestPanelContent = ({ children }: { children: React.ReactNode }) => {
  return (
    <PanelContent css={{ padding: 0, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
      <TopBarPanelContent>{children}</TopBarPanelContent>
    </PanelContent>
  );
};

export const ScheduleRequestPanel = Object.assign(ScheduleRequestPanelWrapper, {
  Header: ScheduleRequestPanelHeader,
  Content: ScheduleRequestPanelContent,
});
